import keyBy from 'lodash/keyBy';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import { type Dispatch, type SetStateAction, useCallback } from 'react';
import type { TransferListBaseItem, TransferListItemsMap } from '../types';

export type UseTransferListBulkActionsArgs<TItem extends TransferListBaseItem> = {
  setLeftItems: Dispatch<SetStateAction<TransferListItemsMap<TItem>>>;
  setLeftSelectedItems: Dispatch<SetStateAction<TransferListItemsMap<TItem>>>;
  setRightItems: Dispatch<SetStateAction<TransferListItemsMap<TItem>>>;
};

export const useTransferListBulkAdd = <TItem extends TransferListBaseItem>({
  setLeftItems,
  setLeftSelectedItems,
  setRightItems,
}: UseTransferListBulkActionsArgs<TItem>) => {
  const handleBulkAdd = useCallback(
    (items: TItem[]) => {
      const itemsIds = items.map(item => item.id);

      setLeftItems(prev => omit(prev, itemsIds));
      setLeftSelectedItems({});
      setRightItems(prev => merge({ ...prev }, keyBy(items, 'id')));
    },
    [setLeftItems, setLeftSelectedItems, setRightItems]
  );

  return {
    handleBulkAdd,
  };
};
